<template>
  <div class="fixed inset-0 bg-gradient-to-b from-[#142a4a] via-[#18365f] to-[#1b4475] overflow-y-auto z-50 pt-24 pb-12">
    <div class="max-w-6xl mx-auto px-4 mt-6">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
        <!-- Coluna esquerda: formulário -->
        <div class="rounded-xl border border-cyan-400/30 bg-slate-900/85 backdrop-blur-sm shadow-xl shadow-black/40 p-8 md:p-10 order-2 lg:order-1">
          <div class="text-center mb-8">
            <h1 class="text-3xl font-bold text-slate-100">PowerAgent</h1>
            <p class="text-slate-400 mt-2">Crie sua conta de ambiente</p>
          </div>

          <form @submit.prevent="handleRegister" class="space-y-4">
          <!-- Tenant Info -->
          <div class="border-b border-slate-600/60 pb-4 mb-4">
           
            <div>
              <label class="block text-sm font-medium text-slate-300 mb-1">Nome da sua Empresa *</label>
              <input
                v-model="form.tenant.name"
                type="text"
                placeholder="Ex: Minha Empresa Ltda"
                required
                class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
              />
            </div>

            <div class="mt-3">
              <label class="block text-sm font-medium text-slate-300 mb-1">Nome para seu Ambiente *</label>
              <input
                v-model="form.tenant.master_code"
                type="text"
                placeholder="Ex: xpto-locacoes"
                @input="validateMasterCode"
                maxlength="25"
                required
                class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
              />
              <p v-if="masterCodeError" class="text-xs text-red-400 mt-1">{{ masterCodeError }}</p>
              <p class="text-xs text-slate-500 mt-1">
                <span class="font-semibold">O Ambiente</span> é o identificador único do seu cliente no PowerAgent (isolamento de dados e URL pública).
                Use apenas letras, números, hífen e underscore, sem espaços ou acentos
                (ex: <span class="font-mono">pousada-sol-nascente</span>). <span class="font-semibold text-red-400"><br>* Anote esse nome, pois ele será usado no login e para divulgação da sua página.</span>
              </p>
            </div>            

            <div class="mt-3">
              <label class="block text-sm font-medium text-slate-300 mb-1">Telefone principal da empresa *</label>
              <input
                v-model="form.tenant.phone"
                type="tel"
                placeholder="(00) 00000-0000"
                @input="onTenantPhoneInput"
                required
                class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
              />
              <p class="text-xs text-slate-500 mt-1">É obrigatório ser um WhatsApp.</p>
            </div>

            <div class="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                
                <label class="block text-sm font-medium text-slate-300 mb-1">Cidade *</label>
                <input
                  v-model="form.tenant.city"
                  type="text"
                  placeholder="Ex: São Paulo"
                  required
                  class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
                />
              </div>
              <div>
                <label class="block text-sm font-medium text-slate-300 mb-1">UF *</label>
                <select
                  v-model="form.tenant.state"
                  required
                  class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70 text-sm"
                >
                  <option value="" class="bg-slate-900">Selecione</option>
                  <option
                    v-for="uf in stateOptions"
                    :key="uf.value"
                    :value="uf.value"
                    class="bg-slate-900"
                  >
                    {{ uf.label }} ({{ uf.value }})
                  </option>
                </select>
              </div>
            </div>

            <div class="mt-3">
              <label class="block text-sm font-medium text-slate-300 mb-1">Perfil do Instagram</label>
              <input
                v-model="form.tenant.instagram_profile"
                type="text"
                placeholder="Ex: https://instagram.com/seu_perfil"
                class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
              />
            </div>

            <div class="mt-3">
              <label class="block text-sm font-medium text-slate-300 mb-1">Perfil do Facebook</label>
              <input
                v-model="form.tenant.facebook_profile"
                type="text"
                placeholder="Ex: https://facebook.com/sua_pagina"
                class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
              />
              <p class="text-xs text-slate-500 mt-1">Informe pelo menos um dos perfis (Instagram ou Facebook).</p>
            </div>
          </div>

          <!-- User Info -->
          <div class="border-b border-slate-600/60 pb-4 mb-4">
            <h3 class="text-sm font-semibold text-slate-200 mb-3">Dados do seu Usuário (para login no ambiente)</h3>
            
              <div class="grid grid-cols-2 gap-3">
                <div>
                  <label class="block text-sm font-medium text-slate-300 mb-1">Nome</label>
                  <input
                    v-model="form.user.first_name"
                    type="text"
                    placeholder="Seu nome"
                    required
                    class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-slate-300 mb-1">Sobrenome</label>
                  <input
                    v-model="form.user.last_name"
                    type="text"
                    placeholder="Seu sobrenome"
                    required
                    class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
                  />
                </div>
              </div>

            <div>
              <label class="block text-sm font-medium text-slate-300 mb-1 mt-3">Email</label>
              <input
                v-model="form.user.email"
                type="email"
                placeholder="seu@email.com"
                required
                class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
              />
            </div>

            <div>
              <label class="block text-sm font-medium text-slate-300 mt-3 mb-1">Telefone</label>
              <input
                v-model="form.user.phone"
                type="tel"
                @input="masks.handlePhoneMaskInput"
                placeholder="(00) 00000-0000"
                class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
              />
            </div>
          </div>

          <!-- Password -->
          <div>
            <label class="block text-sm font-medium text-slate-300 mb-1">Senha</label>
            <input
              v-model="form.user.password"
              type="password"
              placeholder="Mínimo 6 caracteres"
              required
              class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
            />
          </div>

          <div>
            <label class="block text-sm font-medium text-slate-300 mb-1">Confirmar Senha</label>
            <input
              v-model="form.user.password_confirmation"
              type="password"
              placeholder="Confirme sua senha"
              required
              class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
            />
          </div>

          <!-- Checkbox de ciência -->
          <div class="pt-2 border-t border-slate-600/60">
            <label class="flex items-start gap-3 cursor-pointer group">
              <input
                v-model="form.accepted_responsibilities"
                type="checkbox"
                class="mt-1 rounded border-slate-500 bg-slate-800 text-cyan-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40"
              />
              <span class="text-sm text-slate-300 group-hover:text-slate-100">
                Li e estou ciente das <strong>responsabilidades e políticas de uso</strong> descritas ao lado (ou abaixo, no celular) e concordo em ser responsável por todo o conteúdo que publicar na plataforma.
              </span>
            </label>
          </div>

          <div v-if="error" class="bg-red-500/10 border border-red-400/40 text-red-300 px-4 py-3 rounded-lg text-sm">
            {{ error }}
          </div>

          <button
            type="submit"
            :disabled="!isFormValid || loading"
            class="w-full bg-[#2AD7DE] hover:bg-[#5de9f0] text-slate-950 py-2.5 rounded-lg font-semibold transition disabled:opacity-50"
          >
            {{ loading ? 'Criando conta...' : 'Criar Conta' }}
          </button>

          <div class="text-center text-sm mt-4">
            <span class="text-slate-400">Já tem uma conta? </span>
            <button type="button" @click="$emit('switch-to-login')" class="text-cyan-300 font-semibold hover:text-cyan-200">
              Entrar
            </button>
          </div>
        </form>
        </div>

        <!-- Coluna direita: texto explicativo -->
        <div class="order-1 lg:order-2">
          <div class="rounded-xl border border-cyan-400/25 bg-[#435b7c]/90 backdrop-blur-sm shadow-xl shadow-black/40 p-6 md:p-8 lg:sticky lg:top-24">
            <h2 class="text-xl font-bold text-slate-100 mb-4">Para quem é este cadastro?</h2>
            <p class="text-slate-300 mb-4 leading-relaxed">
              Destinado a <strong class="text-slate-100">empresas e equipes</strong> que precisam de um <strong class="text-slate-100">ambiente isolado (tenant)</strong> no PowerAgent para operar produto, integrações e dados com autenticação própria.
            </p>

            <h3 class="text-lg font-semibold text-slate-100 mt-6 mb-2">Suas responsabilidades</h3>
            <p class="text-slate-300 mb-4 leading-relaxed">
              Ao criar um ambiente, você é <strong class="text-slate-100">responsável</strong> pelas informações cadastrais, pelo uso da plataforma e por manter credenciais seguras. O conteúdo e as integrações do seu produto devem estar <strong class="text-slate-100">em conformidade com a lei</strong> e com políticas aplicáveis.
            </p>

            <div class="bg-amber-500/10 border border-amber-400/35 rounded-lg p-4 mt-4">
              <p class="text-sm text-amber-200/95 leading-relaxed">
                <strong>Atenção:</strong> conteúdo ofensivo, discriminatório, ilegal ou tentativas de fraude podem levar à <strong>suspensão ou encerramento do ambiente</strong>. Em casos graves, pode haver acionamento conforme os termos de uso.
              </p>
            </div>

            <p class="text-sm text-slate-400 mt-6 leading-relaxed">
              Ao marcar &quot;Li e estou ciente&quot;, você confirma que leu estas informações e concorda em usar o serviço de forma adequada.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { useBrazilianMasks } from '../composables/useBrazilianMasks.js'
import { BRAZILIAN_STATES } from '../constants/brazilianStates.js'

export default {
  emits: ['register-success', 'switch-to-login'],
  
  data() {
    return {
      loading: false,
      error: '',
      masterCodeError: '',
      masks: useBrazilianMasks(),
      stateOptions: BRAZILIAN_STATES,
      form: {
        accepted_responsibilities: false,
        tenant: {
          name: '',
          master_code: '',
          phone: '',
          city: '',
          state: '',
          instagram_profile: '',
          facebook_profile: ''
        },
        user: {
          email: '',
          phone: '',
          first_name: '',
          last_name: '',
          password: '',
          password_confirmation: ''
        }
      }
    }
  },

  computed: {
    isFormValid() {
      // Verificar se todos os campos obrigatórios estão preenchidos
      const tenantValid = this.form.tenant.name.trim() !== '' && 
                         this.form.tenant.master_code.trim() !== '' &&
                         this.form.tenant.phone.trim() !== '' &&
                         this.form.tenant.city.trim() !== '' &&
                         this.form.tenant.state.trim() !== ''
      
      const userValid = this.form.user.first_name.trim() !== '' &&
                       this.form.user.last_name.trim() !== '' &&
                       this.form.user.email.trim() !== '' &&
                       this.form.user.password.trim() !== '' &&
                       this.form.user.password_confirmation.trim() !== ''
      
      // Verificar se não há erro no master code
      const noMasterCodeError = !this.masterCodeError
      
      // Verificar se as senhas coincidem
      const passwordsMatch = this.form.user.password === this.form.user.password_confirmation

      // Deve ter aceitado as responsabilidades
      const acceptedResponsibilities = this.form.accepted_responsibilities === true

      // Pelo menos um perfil social
      const hasSocialProfile =
        this.form.tenant.instagram_profile.trim() !== '' ||
        this.form.tenant.facebook_profile.trim() !== ''
      
      return tenantValid && userValid && noMasterCodeError && passwordsMatch && acceptedResponsibilities && hasSocialProfile
    }
  },

  methods: {
    onTenantPhoneInput(event) {
      this.masks.handlePhoneInput(event, this.form.tenant)
    },
    validateMasterCode() {
      const masterCode = this.form.tenant.master_code
      
      // Limpar erro se o campo estiver vazio
      if (!masterCode) {
        this.masterCodeError = ''
        return
      }
      
      // Validar comprimento
      if (masterCode.length < 3) {
        this.masterCodeError = 'Ambiente deve ter pelo menos 3 caracteres'
        return
      }

      if (masterCode.length > 25) {
        this.masterCodeError = 'Ambiente deve ter no máximo 25 caracteres'
        return
      }
      
      // Validar caracteres permitidos
      if (!/^[a-zA-Z0-9_-]+$/.test(masterCode)) {
        this.masterCodeError = 'Apenas letras, números, hífen e underscore são permitidos. Sem espaços ou acentos.'
        return
      }
      
      // Se passou em todas as validações, limpar o erro
      this.masterCodeError = ''
    },

    async handleRegister() {
      this.loading = true
      this.error = ''

      if (this.form.user.password !== this.form.user.password_confirmation) {
        this.error = 'As senhas não coincidem'
        this.loading = false
        return
      }

      try {
        const response = await axios.post('/api/v1/tenants/register', {
          tenant: {
            name: this.form.tenant.name,
            master_code: this.form.tenant.master_code,
            phone: this.form.tenant.phone || '',
            city: this.form.tenant.city || '',
            state: this.form.tenant.state || '',
            instagram_profile: this.form.tenant.instagram_profile || '',
            facebook_profile: this.form.tenant.facebook_profile || ''
          },
          user: this.form.user
        })

        const data = response.data
        const tenantInactive = data.tenant && data.tenant.active === false
        const noTokens = !data.tenantToken && !data.userToken

        if (data.tenant?.master_code) {
          localStorage.setItem(
            'lastLoginMasterCode',
            String(data.tenant.master_code).trim().toLowerCase()
          )
        }
        if (data.user?.email) {
          localStorage.setItem('lastLoginEmail', String(data.user.email).trim())
        }

        // Só grava localStorage e “loga” se o tenant estiver ativo (homologado)
        if (!tenantInactive && !noTokens) {
          localStorage.setItem('tenantToken', data.tenantToken)
          localStorage.setItem('userToken', data.userToken)
          localStorage.setItem('tenant', JSON.stringify(data.tenant))
          localStorage.setItem('user', JSON.stringify(data.user))
          localStorage.setItem('masterCode', data.tenant.master_code)
        }

        this.$emit('register-success', {
          tenant: data.tenant,
          user: data.user,
          tenantToken: data.tenantToken,
          userToken: data.userToken
        })
      } catch (err) {
        if (err.response?.data?.errors) {
          this.error = err.response.data.errors.join(', ')
        } else {
          this.error = 'Falha ao criar conta. Tente novamente.'
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
